export enum UserActionType {
  AUTH_REQUEST = 'AUTH_REQUEST',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_FAIL = 'AUTH_FAIL',
  GET_AUTH_TYPE_REQUEST = 'GET_AUTH_TYPE_REQUEST',
  GET_AUTH_TYPE_SUCCESS = 'GET_AUTH_TYPE_SUCCESS',
  GET_AUTH_TYPE_FAIL = 'GET_AUTH_TYPE_FAIL',
  PERMISSION_REQUEST = 'PERMISSION_REQUEST',
  PERMISSION_SUCCESS = 'PERMISSION_SUCCESS',
  PERMISSION_FAIL = 'PERMISSION_FAIL',
  FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL',
  RESET_PASS_REQUEST = 'RESET_PASS_REQUEST',
  RESET_PASS_SUCCESS = 'RESET_PASS_SUCCESS',
  RESET_PASS_FAIL = 'RESET_PASS_FAIL',
  CHANGE_PASS_REQUEST = 'CHANGE_PASS_REQUEST',
  CHANGE_PASS_SUCCESS = 'CHANGE_PASS_SUCCESS',
  CHANGE_PASS_FAIL = 'CHANGE_PASS_FAIL',
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  GET_REFRESH_TOKEN_REQUEST = 'GET_REFRESH_TOKEN_REQUEST',
  GET_REFRESH_TOKEN_SUCCESS = 'GET_REFRESH_TOKEN_SUCCESS',
  GET_REFRESH_TOKEN_FAIL = 'GET_REFRESH_TOKEN_FAIL',
  LOGOUT_REQUEST = 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS = 'LOGOUT_REQUEST',
  LOGOUT_FAIL = 'LOGOUT_REQUEST',

  GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST',
  GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS',
  GET_CURRENT_USER_FAIL = 'GET_CURRENT_USER_FAIL',
  GET_PICKED_USER_REQUEST = 'GET_PICKED_USER_REQUEST',
  GET_PICKED_USER_SUCCESS = 'GET_PICKED_USER_SUCCESS',
  GET_PICKED_USER_FAIL = 'GET_PICKED_USER_FAIL',

  CREATE_USER_REQUEST = 'CREATE_USER_REQUEST',
  CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS',
  CREATE_USER_FAIL = 'CREATE_USER_FAIL',
  CREATE_PASSWORD_REQUEST = 'CREATE_PASSWORD_REQUEST',
  CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS',
  CREATE_PASSWORD_FAIL = 'CREATE_PASSWORD_FAIL',

  EDIT_CURRENT_USER_REQUEST = 'EDIT_CURRENT_USER_REQUEST',
  EDIT_CURRENT_USER_SUCCESS = 'EDIT_CURRENT_USER_SUCCESS',
  EDIT_CURRENT_USER_FAIL = 'EDIT_CURRENT_USER_FAIL',
  EDIT_PICKED_USER_REQUEST = 'EDIT_PICKED_USER_REQUEST',
  EDIT_PICKED_USER_SUCCESS = 'EDIT_PICKED_USER_SUCCESS',
  EDIT_PICKED_USER_FAIL = 'EDIT_PICKED_USER_FAIL',

  DELETE_USER_REQUEST = 'DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS',
  DELETE_USER_FAIL = 'DELETE_USER_FAIL',

  GET_USERS_LIST_REQUEST = 'GET_USERS_LIST_REQUEST',
  GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS',
  GET_USERS_LIST_FAIL = 'GET_USERS_LIST_FAIL',
  GET_ROLES_LIST_REQUEST = 'GET_ROLES_LIST_REQUEST',
  GET_ROLES_LIST_SUCCESS = 'GET_ROLES_LIST_SUCCESS',
  GET_ROLES_LIST_FAIL = 'GET_ROLES_LIST_FAIL',

  GET_TIMEZONES_REQUEST = 'GET_TIMEZONES_REQUEST',
  GET_TIMEZONES_SUCCESS = 'GET_TIMEZONES_SUCCESS',
  GET_TIMEZONES_FAIL = 'GET_TIMEZONES_FAIL',

  CHANGE_FORGOTTEN_PASSWORD_REQUEST = 'CHANGE_FORGOTTEN_PASSWORD_REQUEST',
  CHANGE_FORGOTTEN_PASSWORD_SUCCESS = 'CHANGE_FORGOTTEN_PASSWORD_SUCCESS',
  CHANGE_FORGOTTEN_PASSWORD_FAIL = 'CHANGE_FORGOTTEN_PASSWORD_FAIL',
}
